import styled from 'styled-components';

const Separator = styled.div`
  height: 100%;
  border-radius: 100px;
  background-color: var(--bg-color-white-gray);
`;

export default Separator;
